import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	...window.INITIAL_STATE?.resources,
}

const resourcesSlice = createSlice({
	name: 'resources',
	initialState,
	reducers: {},
})

export const {} = resourcesSlice.actions

export default resourcesSlice.reducer
